var $ = require('jquery');
$(document).ready(function () {
	/*	Accordion
	 *	To make an accordion that utilizes this functionality you must have a specific structure in your
	 *	accordion html element and this function will transform it automatically.
	 *	Structure will have to be as follows:
	 *	<accordion>
	 *		<h2> This is main title over accordion block </h2>
	 *		<h3> <p> This is the title of the accordion element </p> </h3>
	 *		* Any number of elements except h3:s or
	 *		* h2:s are fine to put under the h3
	 *		* and they have to siblings e.g. not
	 *		* inside any element.
	 *		<h2> You can REPEAT </h2>
	 *		<h3> <p> this pattern </p> </h3>
	 *		* however many times
	 *		* you please and it will
	 *		* render properly as long
	 *		* as the structure is
	 *		* followed.
	 *	</accordion>
	 *
	 *	This was done to follow Krisinformation.se:s incoming html by script per 2020.
	 */
	'use strict';
	var accordion = $('.accordion');
	var accordionMainTitles = accordion.find('h2');
	accordionMainTitles.each(function (index) {
		var accordionSegment = $(this).nextUntil('h2');
		accordionSegment.wrapAll('<ul class=\"accordion__container\"></ul>');
	});
	accordion.find('ul').each(function(listindex) {
		$(this).find('h3').each(function (index) {
			var title = $(this).html();
			$(this).replaceWith('<button>' + title + '</button>');
		});

		$(this).find('button').each(function (index) {
			$(this).prepend("<span aria-hidden='true' class=\"expand-icon\">+</span>");
			$(this).attr("aria-expanded", "false");
			$(this).attr("type", "button");

			var id = listindex + '-' + index;
			var controlIds = 'kianswer-' + id + ' kisource-' + id + ' kiupdated-' + id;
			$(this).attr('aria-controls', controlIds);

			$(this).nextUntil('button').add(this).wrapAll('<li class=\"accordion__container-item\"></li>');
		});

		$(this).find('.kianswer').each(function (index) {
			$(this).attr('id', 'kianswer-' + listindex + '-' + index);
		});

		$(this).find('.kisource').each(function (index) {
			$(this).attr('id', 'kisource-' + listindex + '-' + index);
		});

		$(this).find('.kiupdated').each(function (index) {
			$(this).attr('id', 'kiupdated-' + listindex + '-' + index);
		});

		$(this).find('button').each(function (index) {
			$(this).nextUntil('button').hide();
		});
	});
	accordion.on('click',
		'button',
		function () {
			_toggleAccordionElement($(this));
		});

	accordion.find('h2').replaceWith(function () {
		return '<h3>' + $(this).html() + '</h3>';
	});
	accordion.find('h1').replaceWith(function () {
		return '<h2>' + $(this).html() + '</h2>';
	});
});

function _toggleAccordionElement(element) {
	if (element.attr("aria-expanded") === "true") {
		element.children().first().replaceWith("<span aria-hidden='true' class=\"expand-icon\">+</span>");
		element.attr("aria-expanded", "false");
	} else {
		element.children().first().replaceWith("<span aria-hidden='true' class=\"expand-icon\">-</span>");
		element.attr("aria-expanded", "true");
	}
	$(element).nextAll().slideToggle();
};